module.exports = __webpack_public_path__ + "static/media/DSC_0180-2.ad430fac.jpg";